import { isEmpty } from 'lodash';
import { NewsletterFrequencyEnum, WeekDay, weekDays } from '../const';

export const afterFetch = (item: any) => {
  const defaultFrequency = NewsletterFrequencyEnum.weekly;
  const defaultAvailableWeekDays: WeekDay[] = [];

  // For new template
  if (isEmpty(item) || !item) {
    return {
      availableWeekDays: defaultAvailableWeekDays,
      frequency: defaultFrequency,
    };
  }

  // For existing template
  let availableWeekDays: WeekDay[] = [];
  if (item.available) {
    // eslint-disable-next-line fp/no-loops
    for (let index = 0; index < weekDays.length; index++) {
      if (item.available.charAt(index) === '1') {
        // eslint-disable-next-line fp/no-mutating-methods
        availableWeekDays.push({
          value: index,
          label: weekDays[index],
        });
      }
    }
  } else {
    availableWeekDays = defaultAvailableWeekDays;
  }

  const medias = item.medias?.reduce((acc: any, media: any) => {
    // eslint-disable-next-line fp/no-mutating-methods
    acc.push({
      ...media,
      focusPoint: media.focusPoint ? JSON.parse(media.focusPoint) : null,
      iframely: media.iframely.html
        ? media.iframely
        : JSON.parse(media.iframely),
    });

    return acc;
  }, []);

  return {
    ...item,
    ...(!item.available && {
      available: weekDays.map((_, i) => (!i ? '1' : '0')).join(''),
    }),
    ...(!item.frequency && {
      frequency: defaultFrequency,
    }),
    availableWeekDays,
    medias,
  };
};
